import { useQuery } from '@tanstack/react-query';

import Transition from '@/components/Common/Transition';
import queryKeys from '@/configs/react-query-keys';
import service from '@/services/index';

import TopicCard from './TopicCard';

type Props = {
  alias: string;
};

const TopicCardContainer = (props: Props) => {
  const { data, isFetched } = useQuery({
    queryKey: [...queryKeys.taxonomy.TOPIC_DETAIL, props.alias],
    queryFn: () => service.taxonomy.fetchTopicDetail(props.alias),
  });

  return (
    <Transition status={isFetched}>
      {data && <TopicCard topic={data} />}
    </Transition>
  );
};

export default TopicCardContainer;
